import { useCallback, useEffect } from "react";
import { useFocusEffect, useIsFocused } from "@react-navigation/native";
import { useTheme } from "styled-components/native";
import { DeviceEventEmitter, Keyboard } from "react-native";
import { useQueryClient } from "@tanstack/react-query";

interface UsePdpFocusEffectsProps {
  isModal: boolean;
  productType: string | undefined;
  scrollToTop?: () => void;
}

export const usePdpFocusEffects = ({
  isModal,
  productType,
  scrollToTop,
}: UsePdpFocusEffectsProps) => {
  const isFocused = useIsFocused();
  const theme = useTheme();
  const queryClient = useQueryClient();

  useFocusEffect(
    useCallback(() => {
      return () => {
        Keyboard.dismiss();
      };
    }, [])
  );

  useEffect(() => {
    // Scroll to top when screen comes into focus on mobile
    if (isFocused && theme.isMobile && scrollToTop) {
      scrollToTop();
    }

    // Emit device event and refetch queries when screen comes into focus (non-modal)
    if (isFocused && !isModal) {
      DeviceEventEmitter.emit("builderProductChange", {
        screen: "pdp-screen",
        productType,
      });
      queryClient.refetchQueries({ queryKey: ["PRODUCT_PAGE"] }).then();
    }
  }, [
    isFocused,
    theme.isMobile,
    scrollToTop,
    isModal,
    productType,
    queryClient,
  ]);
};
